<template>
  <div class="bg-full-screen-image login-page">
    <div class="app-content content">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
        </div>
        <div class="content-body">
          <!-- error 404 -->
          <section class="row flexbox-container">
            <div class="col-xl-7 col-md-8 col-12 d-flex justify-content-center">
              <div class="card auth-card bg-transparent shadow-none rounded-0 mb-0 w-100">
                <div class="card-content">
                  <div class="card-body text-center">
                    <img src="img/404.png" class="img-fluid align-self-center" alt="branding logo">
                    <h1 class="font-large-2 my-1">{{ lexicon.drop_drop_404_title }}</h1>
                    <p class="p-2">
                      {{ lexicon.drop_404_subtitle }}
                    </p>
                    <a class="btn btn-primary btn-lg mt-2" href="/">{{lexicon.drop_to_home}}</a>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- error 404 end -->

        </div>
      </div>
    </div>
  </div>

</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'NotFound',
  computed: mapState({
    lexicon: state => state.lexicon
  }),
}
</script>
